export const parseResultData = (result: string) => {
  try {
    return JSON.parse(result) as { time: string; value: number }[];
  } catch (error) {
    console.error("❌ JSON 파싱 오류:", error);
    return [];
  }
};
